export default "__VITE_ASSET__BBdHZtZt__"